import React, { useState, useLayoutEffect } from "react";
import { Link } from "gatsby";
import HamburgerMenu from "react-hamburger-menu";
import Flag from "react-world-flags";

import * as classes from "./Header.module.css";
import useWelsh, { useWelshMap } from "../../useWelsh";

const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState({
    width: null,
    height: null,
  });

  useLayoutEffect(() => {
    const handleResize = () => {
      const { innerWidth: width, innerHeight: height } = window;
      setWindowDimensions({ width, height });
    };

    if (window) {
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  return windowDimensions;
};

const map = {
  english: {
    title: "Penpergwm Solar Farm",
    about: "About Us",
    proposal: "The Proposal",
    community: "Community",
    why: "Why Solar?",
    contact: "Contact",
    switch: "Switch to Welsh",
    faq: "FAQs",
    documents: "Documents",
    process: "The Process",
  },
  welsh: {
    title: "Fferm Solar Penpergwm",
    about: "Gair Amdanom",
    proposal: "Y Cynnig",
    community: "Y Gymuned",
    why: "Pam Solar?",
    contact: "Cysylltwch",
    switch: "Newid i'r Saesneg",
    faq: "Cwestiynau Cyffredin",
    documents: "Dogfennau",
    process: "Y Broses",
  },
};

const CHANGE_WIDTH = 1000;

const Header = ({ setWelsh }) => {
  const welsh = useWelsh();
  const text = useWelshMap(map);
  const { width } = useWindowDimensions();
  const [toggled, setToggled] = useState(false);

  return (
    <div className={classes.headerContainer}>
      <div className={classes.headerContent}>
        <Link to="/" onClick={() => setToggled(false)}>
          <div className={classes.logo}>
            <h2>{text.title}</h2>
          </div>
        </Link>
        {width && (
          <>
            <div className={toggled ? classes.links : classes.hidden}>
              <Link to="/proposal" onClick={() => setToggled(false)}>
                {text.proposal}
              </Link>
              <Link to="/process" onClick={() => setToggled(false)}>
                {text.process}
              </Link>
              <Link
                to="/frequently-asked-questions"
                onClick={() => setToggled(false)}
              >
                {text.faq}
              </Link>
              <Link to="/documents" onClick={() => setToggled(false)}>
                {text.documents}
              </Link>
              <Link to="/about-us" onClick={() => setToggled(false)}>
                {text.about}
              </Link>
              <Link to="/contact" onClick={() => setToggled(false)}>
                {text.contact}
              </Link>
              {/* <span
                role="button"
                tabIndex="0"
                onClick={() => {
                  setWelsh(w => !w);
                  setToggled(false);
                }}
                onKeyDown={() => {
                  setWelsh(w => !w);
                  setToggled(false);
                }}
              >
                {width < CHANGE_WIDTH && text.switch}
                {welsh ? (
                  <Flag code="GB" width={30} />
                ) : (
                  <Flag code="GB-WLS" width={30} />
                )}
              </span> */}
            </div>
            {width <= CHANGE_WIDTH && (
              <HamburgerMenu
                className={classes.menu}
                isOpen={toggled}
                menuClicked={() => setToggled(t => !t)}
                width={25}
                height={20}
                strokeWidth={2}
                color="black"
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Header;
